"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterSelections = exports.FilterInput = exports.InputType = void 0;
var react_1 = __importStar(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var filter_input_styles_1 = require("./filter_input.styles");
var immutable_1 = require("immutable");
var checkbox_input_1 = require("./checkbox-input");
var radio_input_1 = require("./radio-input");
var InputType;
(function (InputType) {
    InputType[InputType["RADIO"] = 0] = "RADIO";
    InputType[InputType["CHECKBOX"] = 1] = "CHECKBOX";
})(InputType = exports.InputType || (exports.InputType = {}));
var FilterPopoverContent = function (props) {
    var filtersLabel = props.filtersLabel, applyLabel = props.applyLabel, removeLabel = props.removeLabel, cancelLabel = props.cancelLabel, selected = props.selected, inputType = props.inputType, onClickRemove = props.onClickRemove, onClickCancel = props.onClickCancel, onClickApply = props.onClickApply;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(filter_input_styles_1.FilterInputHeader, null,
            react_1.default.createElement(storm_ui_1.Text, { type: 'h3' }, filtersLabel),
            react_1.default.createElement(storm_ui_1.TextButton, { onClick: onClickRemove }, removeLabel)),
        inputType === InputType.RADIO ? react_1.default.createElement(radio_input_1.RadioInputGroup, __assign({}, props)) : react_1.default.createElement(checkbox_input_1.CheckboxInputGroup, __assign({}, props)),
        react_1.default.createElement(filter_input_styles_1.FilterInputFooter, null,
            react_1.default.createElement(filter_input_styles_1.CancelButton, { onClick: onClickCancel }, cancelLabel),
            react_1.default.createElement(filter_input_styles_1.ApplyButton, { onClick: onClickApply, disabled: selected.size === 0, primary: true }, applyLabel))));
};
var FilterInput = /** @class */ (function (_super) {
    __extends(FilterInput, _super);
    function FilterInput(props) {
        var _this = _super.call(this, props) || this;
        _this.filterDropdownRef = (0, react_1.createRef)();
        _this.state = { filter: { label: '', value: '', options: immutable_1.OrderedSet.of(), selected: immutable_1.OrderedSet.of() }, isPopoverOpen: false };
        return _this;
    }
    FilterInput.prototype.render = function () {
        var _this = this;
        var _a;
        var filterPopoverContentProps = __assign(__assign({ filtersLabel: this.state.filter.label, applyLabel: this.props.applyLabel, cancelLabel: this.props.cancelLabel, removeLabel: this.props.removeLabel, selected: this.state.filter.selected, options: this.state.filter.options, inputType: this.state.filter.inputType }, (this.state.filter.inputType === InputType.RADIO && __assign({}, (0, radio_input_1.radioInputGroupProps)(this)))), (this.state.filter.inputType === InputType.CHECKBOX && __assign({}, (0, checkbox_input_1.checkboxInputGroupProps)(this))));
        var filterSelection;
        if (this.props.filters.length === 1) {
            filterSelection = (react_1.default.createElement(storm_ui_1.UIDConsumer, { value: 'dropdown-filter-selection' }, function (uid) { return (react_1.default.createElement(storm_ui_1.Button, { id: uid, value: _this.props.filters[0].label, onClick: function () {
                    _this.setState({ filter: _this.props.filters[0], isPopoverOpen: true });
                } },
                _this.props.filtersLabel,
                react_1.default.createElement(filter_input_styles_1.StyledIcon, { type: "angle-down" }))); }));
        }
        if (this.props.filters.length > 1) {
            filterSelection = (react_1.default.createElement(storm_ui_1.UIDConsumer, { value: 'dropdown-filter-selection' }, function (uid) { return (react_1.default.createElement(storm_ui_1.Dropdown, { id: uid, selectedValue: _this.state.filter.label, onChange: function (filter) {
                    _this.setState({ filter: filter, isPopoverOpen: true });
                }, onOverrideLabel: function () { return _this.props.filtersLabel; } }, _this.props.filters.map(function (filter, i) {
                return (react_1.default.createElement(storm_ui_1.DropdownItem, { key: i, value: filter }, filter.label));
            }))); }));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(filter_input_styles_1.StyledPopover, { isOpen: this.state.isPopoverOpen, anchorEl: (_a = this.filterDropdownRef.current) !== null && _a !== void 0 ? _a : undefined, withBackdrop: true, onClose: function () { return _this.setState({ isPopoverOpen: false }); } },
                react_1.default.createElement(FilterPopoverContent, __assign({}, filterPopoverContentProps))),
            react_1.default.createElement("div", { ref: this.filterDropdownRef }, filterSelection)));
    };
    return FilterInput;
}(react_1.Component));
exports.FilterInput = FilterInput;
var FilterSelections = function (props) { return (react_1.default.createElement(filter_input_styles_1.StyledFilterSelections, null,
    react_1.default.createElement(filter_input_styles_1.FilterElement, null,
        react_1.default.createElement(storm_ui_1.Text, { type: 'h5' }, props.filtersLabel)),
    props.appliedFilters
        .filter(function (filter) { return filter.selected.size !== 0; })
        .map(function (filter) {
        return filter.selected.map(function (option) {
            return (react_1.default.createElement(filter_input_styles_1.FilterElement, { key: option.value },
                react_1.default.createElement(storm_ui_1.Pill, { key: option.value, "data-testid": filter.label + ': ' + option.value, onClose: function () {
                        return props.setAppliedFilters(function (prev) {
                            return prev.map(function (filter) {
                                filter.selected = filter.selected.has(option) ? filter.selected.delete(option) : filter.selected;
                                return filter;
                            });
                        });
                    }, label: filter.label + ': ' + option.label })));
        });
    }),
    react_1.default.createElement(filter_input_styles_1.FilterElement, null,
        react_1.default.createElement(filter_input_styles_1.ResetButton, { onClick: function () {
                props.setAppliedFilters(function (prev) {
                    return prev.map(function (filter) {
                        filter.selected = (0, immutable_1.OrderedSet)();
                        return filter;
                    });
                });
            } }, props.resetLabel)))); };
exports.FilterSelections = FilterSelections;
